export default __webpack_public_path__ + "static/media/080_finish_soso.hevc.ba2bb0f1.mp4";